import qs from 'qs';

import { Organization } from "../../types";
import { get, remove } from '../api';

export type InternalToolsOrgFilterOptions = {
  freeFilterEnabled: boolean;
  premiumFilterEnabled: boolean;
  premiumSeatFilterEnabled: boolean;
  premiumSeat2FilterEnabled: boolean;
  premiumComplianceFilterEnabled: boolean;
  premiumCompSecFilterEnabled: boolean;
  contributorCountFilterEnabled: boolean;
  andOrToggle: boolean;
  contributorCountRange: {
    min: number;
    max: number;
  };
  textFilter: string;
  selectedOrg: Organization;
};

// ORG related
export const SET_ORG_TEXT_FILTER = 'SET_ORG_TEXT_FILTER';
export const TOGGLE_FREE_FILTER = 'TOGGLE_FREE_FILTER';
export const TOGGLE_PREMIUM_FILTER = 'TOGGLE_PREMIUM_FILTER';
export const TOGGLE_PREMIUM_SEAT_FILTER = 'TOGGLE_PREMIUM_SEAT_FILTER';
export const TOGGLE_PREMIUM_SEAT2_FILTER = 'TOGGLE_PREMIUM_SEAT2_FILTER';
export const TOGGLE_PREMIUM_COMPLIANCE_FILTER = 'TOGGLE_PREMIUM_COMPLIANCE_FILTER';
export const TOGGLE_PREMIUM_COMP_SEC_FILTER = 'TOGGLE_PREMIUM_COMP_SEC_FILTER';
export const TOGGLE_STRIPE_ACCOUNT_FILTER = 'TOGGLE_STRIPE_ACCOUNT_FILTER';
export const TOGGLE_CONTRIBUTOR_COUNT_FILTER = 'TOGGLE_CONTRIBUTOR_COUNT_FILTER';
export const TOGGLE_CUSTOM_BILLING_FILTER = 'TOGGLE_CUSTOM_BILLING_FILTER';
export const SET_CONTRIBUTOR_COUNT_FILTER = 'SET_CONTRIBUTOR_COUNT_FILTER';
export const TOGGLE_AND_OR = 'TOGGLE_AND_OR_FILTER';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const SET_SELECTED_ORG = 'SET_SELECTED_ORG';
export const START_LICENSE_CACHE_MIGRATION = 'START_LICENSE_CACHE_MIGRATION';
export const FETCH_ORGS = 'INTERNAL_MODULE_FETCH_ORGS';
export const TOGGLE_PROJECT_COUNT_FILTER = 'TOGGLE_PROJECT_COUNT_FILTER';
export const SET_PROJECT_COUNT_FILTER = 'SET_PROJECT_COUNT_FILTER';
export const DELETE_ORG = 'INTERNAL_TOOLING_DELETE_ORG';

// USER related
export const SET_USER_TEXT_FILTER = 'SET_USER_TEXT_FILTER';
export const FETCH_USERS = 'INTERNAL_MODULE_FETCH_USERS';
export const DELETE_USER = 'INTERNAL_MODULE_DELETE_USER';
export const UPDATE_USER = 'INTERNAL_MODULE_UPDATE_USER';

const internalToolingActions = {
  // ORG related
  setOrgTextFilter: (filter: string) => {
    return {
      filter,
      type: SET_ORG_TEXT_FILTER,
    };
  },
  toggleFreeFilter: () => ({
    type: TOGGLE_FREE_FILTER,
  }),
  togglePremiumFilter: () => ({
    type: TOGGLE_PREMIUM_FILTER,
  }),
  togglePremiumSeatFilter: () => ({
    type: TOGGLE_PREMIUM_SEAT_FILTER,
  }),
  togglePremiumSeat2Filter: () => ({
    type: TOGGLE_PREMIUM_SEAT2_FILTER,
  }),
  togglePremiumComplianceFilter: () => ({
    type: TOGGLE_PREMIUM_COMPLIANCE_FILTER,
  }),
  togglePremiumCompSecFilter: () => ({
    type: TOGGLE_PREMIUM_COMP_SEC_FILTER,
  }),
  toggleContributorCountFilter: () => ({
    type: TOGGLE_CONTRIBUTOR_COUNT_FILTER,
  }),
  toggleAndOrFilter: () => ({
    type: TOGGLE_AND_OR,
  }),
  toggleCustomBillingFilter: () => ({
    type: TOGGLE_CUSTOM_BILLING_FILTER,
  }),
  setContributorCountFilter: (min: number, max: number) => ({
    type: SET_CONTRIBUTOR_COUNT_FILTER,
    range: {
      min,
      max,
    },
  }),
  setSelectedOrg: (org) => {
    return {
      org,
      type: SET_SELECTED_ORG,
    };
  },
  fetchOrgs: (options) => {
    return {
      type: FETCH_ORGS,
      async payload() {
        return get(`/api/internal-tools/orgs?${qs.stringify(options)}`);
      },
    };
  },
  toggleProjectCountFilter: () => {
    return {
      type: TOGGLE_PROJECT_COUNT_FILTER,
    };
  },
  setProjectCountFilter: (min: number, max: number) => ({
    type: SET_PROJECT_COUNT_FILTER,
    range: {
      min,
      max,
    },
  }),
  deleteOrg: (orgId: number) => ({
    type: DELETE_ORG,
    async payload() {
      return remove(`/api/internal-tools/organization/${orgId}`);
    },
  }),
};

export default internalToolingActions;
